import * as React from "react";

export const ShortcutUserIcon = (props: any) => (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.5 9c-.245 3.304-2.75 6-5.5 6s-5.26-2.695-5.5-6c-.25-3.438 2.188-6 5.5-6 3.313 0 5.75 2.625 5.5 6Z"
      stroke="#2D5BFF"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 19c-5.438 0-10.956 3-11.978 8.663-.125.682.264 1.337.979 1.337H29c.715 0 1.101-.655.978-1.337C28.956 22 23.438 19 18 19Z"
      stroke="#2D5BFF"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M5.5 11v7M9 14.5H2"
      stroke="#2D5BFF"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
